module.exports = __webpack_public_path__ + "img/opinion.331d8f7a.png";